import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import JSZip from "jszip";
import ReactCrop, { makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

/* services */
import {
  studentByFields,
  importImgsStudents,
} from "../../../api/StudentsReport";

/**Elements */
import TextLoading from "../../global/TextLoading";
import ModalSuccess from "../../global/modals/ModalSuccess";

/** Valores del crop */
const height = window.innerHeight;
const minDimension = 150;
const aspectRadio = 1;
const scale = 1;
const rotate = 0;
const lazyLoadingStyles = {
  img: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    background: "#eee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
  },
  lazy: {
    height: "15px",
  },
  btn: {
    minWidth: "120px",
    height: "25px",
  },
};

const customStyles = {
  imgContainer: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    border: "1px solid #ddd",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // marginBottom: "10px",
    // centrar verticalmente el contenido
    // verticalAlign: "middle",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
  iconsBar: {
    width: "5%",
    verticalAlign: "super",
    display: "contents",
    fontSize: 20,
    lineHeight: 1,
  },
  sliderContainer: {
    marginTop: 20,
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  slider: {
    width: "90%",
    appearance: "none",
    height: 2,
    background: "#d3d3d3",
    outline: "none",
    borderRadius: 2,
    padding: 0,
    margin: 0,
    marginBottom: "8px",
    marginTop: "9px",
  },
};
export default function ModalProcessingProfilePhotos(props) {
  const [t] = useTranslation(["student", "global"]);
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [showList, setShowList] = useState(true);
  const [listImages, setListImages] = useState([]);
  const [noStudentFound, setNoStudentFound] = useState([]);
  const [activeImport, setActiveImport] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);

  /**  Modal processing photos*/
  const [showModalProcessingPhotos, setShowModalProcessingPhotos] =
    useState(false);
  const [errorListImages, setErrorListImages] = useState(null);

  /** Modal delete item */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState({
    url: "",
    name: "",
    student: {
      full_name: "",
      school_level: "",
      grade_group: "",
    },
  });

  /**Modal edit photo */
  const [itemToEdit, setItemToEdit] = useState({
    url: "",
    name: "",
    student: {
      full_name: "",
      school_level: "",
      grade_group: "",
    },
  });
  const [crop, setCrop] = useState();
  const [cropSliderValue, setCropSliderValue] = useState(0); // porcentaje del tamaño inicial
  const imgRef = React.useRef(null);
  const [completedCrop, setCompletedCrop] = useState();
  const [errorEditPhoto, setErrorEditPhoto] = useState(null);
  const [imageFocusSize, setImageFocusSize] = useState(null);

  // Styles for the red thumb of the slider
  const sliderThumbStyle = `
  #cropSizeSlider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ea2c54;
    cursor: pointer;
    box-shadow: 0 0 2px #0003;
    border: 2px solid #fff;
  }
  #cropSizeSlider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ea2c54;
    cursor: pointer;
    border: 2px solid #fff;
  }
  #cropSizeSlider::-ms-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ea2c54;
    cursor: pointer;
    border: 2px solid #fff;
  }
  `;

  // Inject the red thumb style only once
  useEffect(() => {
    if (!document.getElementById("slider-red-thumb-style")) {
      const style = document.createElement("style");
      style.id = "slider-red-thumb-style";
      style.innerHTML = sliderThumbStyle;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    Sentry.setTag("section", "Import Student Modal");
    loadImagesFromZip();
  }, []);

  // Eliminada la versión duplicada de loadImagesFromZip, solo queda la que convierte a WebP
  // Convierte un blob de imagen a WebP usando canvas
  const convertToWebP = (blob) => {
    return new Promise((resolve) => {
      const img = new window.Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        canvas.toBlob(
          (webpBlob) => {
            resolve(webpBlob);
          },
          "image/webp",
          0.75
        );
      };
      img.src = URL.createObjectURL(blob);
    });
  };

  const loadImagesFromZip = async () => {
    try {
      const loadedZip = await JSZip.loadAsync(props.imageZipFile[0]);
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".webp",
      ];
      const imagePromises = [];
      loadedZip.forEach((relativePath, file) => {
        if (!file.dir) {
          const isImage = imageExtensions.some((ext) =>
            file.name.toLowerCase().endsWith(ext)
          );
          if (isImage) {
            imagePromises.push(
              file.async("arraybuffer").then(async (content) => {
                const originalBlob = new Blob([content]);
                // const webpBlob = await convertToWebP(originalBlob);
                return {
                  name: file.name,
                  identifier: file.name.split(".")[0],
                  blob: originalBlob,
                  url: URL.createObjectURL(originalBlob),
                };
              })
            );
          }
        }
      });
      const imagesWithUrls = await Promise.all(imagePromises);
      //   setListImages(imagesWithUrls);
      obtaiIdentifiers(imagesWithUrls);
    } catch (err) {
      setListImages([]);
    }
  };

  /**
   * Obtain identifiers from images
   * @param {*} imagesWithUrls
   */
  const obtaiIdentifiers = (imagesWithUrls) => {
    // recuperar solo los identifiers en un solo string separado por comas
    const identifiersString = imagesWithUrls
      .map((image) => image.identifier)
      .join(",");
    getStudentsList(identifiersString, imagesWithUrls);
  };

  /**
   * Obtain students list filtered by identifiers
   * @param {*} identifiersString
   * @param {*} imagesWithUrls
   */
  const getStudentsList = (identifiersString, imagesWithUrls) => {
    const payload = {
      fields: "curp_or_unique_id",
      values: identifiersString,
    };

    studentByFields(payload)
      .then((response) => {
        if (response.data) {
          const studentsFound = response.data.data;
          const imagesWithUrlsMapped = imagesWithUrls.map((image) => {
            const matchedStudent = studentsFound.find((student) => {
              return (
                student.curp?.toLowerCase() ===
                  image.identifier.toLowerCase() ||
                student.student_unique_id?.toLowerCase() ===
                  image.identifier.toLowerCase()
              );
            });
            return {
              ...image,
              student: matchedStudent || null,
            };
          });
          const imagesWithUrlsMappedFiltered = imagesWithUrlsMapped.filter(
            (image) => image.student !== null
          );
          const noFound = imagesWithUrlsMapped.filter(
            (image) => image.student === null
          );
          const identifiersnoFound = noFound
            .map((image) => image.identifier)
            .join(",");
          setNoStudentFound(identifiersnoFound);
          setListImages(imagesWithUrlsMappedFiltered);
          setActiveImport(imagesWithUrlsMappedFiltered.length > 0);
        } else {
          setListImages([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching students:", error);
        setLoading(false);
      });
  };

  /** Lazy loading student item */
  const lazyLoadingStudennItem = () => {
    return (
      <Container>
        {new Array(3).fill(0).map((_, index) => (
          <Row key={index}>
            <Col xs={12} sm={7} md={7} lg={7}>
              <Row className="table-lazyLoading">
                <Col xs={4} sm={4} md={4} lg={4}>
                  <div style={lazyLoadingStyles.img}></div>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8}>
                  <div style={lazyLoadingStyles.lazy}></div>
                  <div style={lazyLoadingStyles.lazy}></div>
                  <div style={lazyLoadingStyles.lazy}></div>
                  <div style={lazyLoadingStyles.lazy}></div>
                </Col>
              </Row>
            </Col>
            <Col
              xs={12}
              sm={4}
              md={4}
              lg={4}
              className="d-flex justify-content-end align-items-center table-lazyLoading"
            >
              <Row className="table-lazyLoading">
                <div style={lazyLoadingStyles.btn}></div>
              </Row>
            </Col>
            <Col
              xs={12}
              sm={1}
              md={1}
              lg={1}
              className="d-flex justify-content-end align-items-center table-lazyLoading"
            >
              <Row className="table-lazyLoading">
                <div style={lazyLoadingStyles.lazy}></div>
              </Row>
            </Col>
          </Row>
        ))}
      </Container>
    );
  };

  const toggleAdjustPhoto = (image) => {
    // validar que la imagen no sea menor al minimo establecido
    const img = new Image();
    img.src = image.url;
    img.addEventListener("load", (e) => {
      const { width, height } = e.currentTarget;
      if (width < minDimension || height < minDimension) {
        setErrorEditPhoto(
          t("student:ModalImportProfilePhotos.minimumImageSize", {
            size: minDimension,
          })
        );
        return;
      }
    });

    setItemToEdit(image);
    setShowModalProcessingPhotos(true);
    setShowList(false);
  };

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const minSide = Math.min(width, height);
    const maxSide = Math.max(width, height);
    const positionY = width > height ? 0 : maxSide / 2 - minSide / 2;
    const positionX = height > width ? 0 : maxSide / 2 - minSide / 2;
    setImageFocusSize(minSide);
    const newCrop = makeAspectCrop(
      {
        unit: "px",
        width: minSide,
        x: positionX,
        y: positionY,
      },
      aspectRadio,
      width,
      height
    );
    setCrop(newCrop);
    setCropSliderValue(0); // 100% del tamaño inicial
  };

  // Adjust the slider to change the crop size
  const handleCropSlider = (value) => {
    if (!imgRef.current) return;
    const img = imgRef.current;
    const imgWidth = img.width;
    const imgHeight = img.height;
    const minSide = Math.min(imgWidth, imgHeight);
    const cropSize = minSide - value;
    // Mantener posicion actual del crop
    const x = crop ? crop.x : Math.round((imgWidth - cropSize) / 2);
    const y = crop ? crop.y : Math.round((imgHeight - cropSize) / 2);
    // validar que el crop no se salga de los margenes de la imagen
    if (x < 0 || y < 0 || x + cropSize > imgWidth || y + cropSize > imgHeight) {
      return;
    }
    setCrop({
      unit: "px",
      width: cropSize,
      height: cropSize,
      x,
      y,
      aspect: aspectRadio,
    });
    setCropSliderValue(value);
  };

  // Function to crop the image and return a WebP blob
  const getCroppedImgWebP = async (image, crop) => {
    if (
      !crop ||
      !image ||
      typeof crop.x !== "number" ||
      typeof crop.y !== "number" ||
      typeof crop.width !== "number" ||
      typeof crop.height !== "number"
    )
      return null;
    // Usar siempre las dimensiones naturales de la imagen
    const naturalWidth = image.naturalWidth;
    const naturalHeight = image.naturalHeight;
    // El crop debe estar en coordenadas relativas a la imagen original
    const scaleX = naturalWidth / image.width;
    const scaleY = naturalHeight / image.height;
    // Si el crop viene en px relativos al render, convertir a naturales
    let cropX = Math.round(crop.x * scaleX);
    let cropY = Math.round(crop.y * scaleY);
    let cropW = Math.round(crop.width * scaleX);
    let cropH = Math.round(crop.height * scaleY);

    // Ensure crop area does not exceed image boundaries
    cropX = Math.max(0, Math.min(cropX, naturalWidth - 1));
    cropY = Math.max(0, Math.min(cropY, naturalHeight - 1));
    cropW = Math.max(1, Math.min(cropW, naturalWidth - cropX));
    cropH = Math.max(1, Math.min(cropH, naturalHeight - cropY));

    const canvas = document.createElement("canvas");
    canvas.width = cropW;
    canvas.height = cropH;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(image, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
    return new Promise((resolve) => {
      canvas.toBlob(
        (blob) => {
          resolve(blob);
        },
        "image/webp",
        0.8
      );
    });
  };

  /**
   * Remove item from list
   * @param {*} item
   */
  const removeItemFromList = (item) => {
    const updatedList = listImages.filter((image) => image !== item);
    setListImages(updatedList);
    setShowDeleteModal(false);
    setShowList(true);
  };

  const sendImportPhotos = async (studentDAta) => {
    setIsSaving(true);
    // crear payload binario
    const payloadBinary = new FormData();
    payloadBinary.append("no_found_file[0]", noStudentFound);
    payloadBinary.append("invalid_format_file", JSON.stringify([]));

    for (let i = 0; i < studentDAta.length; i++) {
      const item = studentDAta[i];
      payloadBinary.append(`students[${i}][student_id]`, item.student_id);
      // Usar nombre personalizado si existe, si no, uno por defecto
      const fileName = item.fileName || `student_${item.fileName}.webp`;
      const file = new File([item.file], fileName, { type: "image/webp" });
      payloadBinary.append(`students[${i}][file]`, file);
    }

    importImgsStudents(payloadBinary)
      .then((response) => {
        if (!response.data) {
          setIsSaving(false);
          setErrorListImages(response.description);
          return;
        }
        setShowModalSuccess(true);
        setShowList(false);
        setIsSaving(false);
      })
      .catch((error) => {
        console.error("Error importing images:", error);
      });
  };

  const studentsPayload = () => {
    setIsSaving(true);
    let data = [];
    listImages.forEach((item) => {
      data.push({
        student_id: item.student.student_id,
        file: convertToWebP(item.blob),
        fileName: item.name,
      });
    });
    // preparar las promesas de conversión a WebP
    const conversionPromises = data.map(async (item) => {
      const webpBlob = await item.file;
      return {
        student_id: item.student_id,
        file: webpBlob,
        fileName: item.fileName,
      };
    });

    // esperar a que todas las conversiones se completen
    Promise.all(conversionPromises).then((convertedData) => {
      sendImportPhotos(convertedData);
    });
  };

  return (
    <>
      {/** Modal Listar fotos*/}
      <Modal
        show={showList}
        size="lg"
        aria-labelledby="contained-modal-title-lg"
        // className="modal-custom-width"
        // style={{ "--modal-width": "605px" }}
      >
        <Modal.Header className="modal-header">
          <Modal.Title className="modal-title text-center">
            {t("student:ModalImportProfilePhotos.titleModalConfirm")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: height - 200 + "px",
            overflow: "auto",
          }}
        >
          {loading && lazyLoadingStudennItem()}
          {listImages.length > 0 && (
            <Container>
              {listImages.map((image, index) => (
                <Row key={index} style={{ marginBottom: "20px" }}>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <Row>
                      <Col
                        xs={4}
                        sm={4}
                        md={4}
                        lg={4}
                        className="ps-0 d-flex align-items-center justify-content-center"
                        style={{}}
                      >
                        <div style={customStyles.imgContainer}>
                          <img
                            id={"studentProfilePhoto_" + index}
                            src={image.url}
                            alt={image.name}
                            style={customStyles.img}
                          />
                        </div>
                      </Col>
                      <Col xs={8} sm={8} md={8} lg={8}>
                        <b>{image.student.full_name}</b>
                        <br />
                        <b>
                          {image.student.school_level}
                          {" - "}
                          {image.student.grade_group &&
                          image.student.grade_group !== "N/A"
                            ? image.student.grade_group
                            : image.student.program_name}
                        </b>
                        <br />
                        <b>
                          {t("student:ModalImportProfilePhotos.curp")}:
                        </b>{" "}
                        {image.student.curp || "N/A"}{" "}
                        <b>{t("student:ModalImportProfilePhotos.idNumber")}:</b>{" "}
                        {image.student.student_unique_id || "N/A"}
                        <br />
                        <p>{image.name}</p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    md={3}
                    lg={3}
                    className="d-flex justify-content-end align-items-center"
                  >
                    <Button
                      id={"adjustPhotoBtn_" + index}
                      variant="outline-secondary"
                      onClick={() => toggleAdjustPhoto(image)}
                    >
                      {t("student:ModalImportProfilePhotos.adjustPhoto")}
                    </Button>
                  </Col>
                  <Col
                    xs={12}
                    sm={1}
                    md={1}
                    lg={1}
                    className="d-flex justify-content-end align-items-center"
                  >
                    <i
                      id={"deletePhotoBtn_" + index}
                      className="bi bi-trash"
                      role="button"
                      style={{ fontSize: "15px" }}
                      onClick={() => {
                        setItemToDelete(image);
                        setShowDeleteModal(true);
                        setShowList(false);
                      }}
                    ></i>
                  </Col>
                </Row>
              ))}
            </Container>
          )}
          {!loading && listImages.length == 0 && (
            <p style={{ textAlign: "center" }}>
              {t("student:ModalImportProfilePhotos.noMatchesFound")}
            </p>
          )}

          {errorListImages && (
            <Alert variant="warning"> {errorListImages}</Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            id="cancelImportPhotos"
            style={{ marginRight: "10px" }}
            variant="outline-secondary"
            disabled={isSaving}
            onClick={() => props.setShowModalProcessingPhotos(false)}
          >
            {t("global:buttons.cancel")}
          </Button>
          <Button
            id="sendImportPhotosBtn"
            variant="primary"
            disabled={!activeImport || isSaving}
            onClick={() => studentsPayload()}
          >
            {isSaving ? (
              <TextLoading
                text={t("global:buttons.importing")}
                variant="light"
              />
            ) : (
              t("student:ModalImportProfilePhotos.confirm")
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/** Modal para editar foto*/}
      <Modal
        show={showModalProcessingPhotos}
        size="md"
        aria-labelledby="contained-modal-title-md"
      >
        <Modal.Header className="modal-header">
          <Modal.Title className="modal-title text-center">
            {t("student:ModalImportProfilePhotos.adjustProfilePicture")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: height - 200 + "px",
            overflow: "auto",
            textAlign: "center",
          }}
        >
          {errorEditPhoto ? (
            <p style={{ color: "red", marginBottom: "10px" }}>
              {errorEditPhoto}
            </p>
          ) : (
            <>
              <ReactCrop
                crop={crop}
                circularCrop
                keepSelection
                aspect={aspectRadio}
                minWidth={minDimension}
                onChange={(c) => {
                  setCrop(c);
                  setCropSliderValue(imageFocusSize - c.width);
                }}
                onComplete={(c) => setCompletedCrop(c)}
              >
                <img
                  id="imageToCrop"
                  ref={imgRef}
                  alt="Crop me"
                  src={itemToEdit.url}
                  style={{
                    transform: `scale(${scale}) rotate(${rotate}deg)`,
                    maxHeight: "70vh",
                  }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
              {/* Slider para el tamaño del crop */}
              <div style={customStyles.sliderContainer}>
                <i style={customStyles.iconsBar} className="bi bi-dash"></i>
                <input
                  id="cropSizeSlider"
                  type="range"
                  min={0}
                  max={imageFocusSize - minDimension}
                  value={cropSliderValue}
                  onChange={(e) => handleCropSlider(Number(e.target.value))}
                  style={customStyles.slider}
                />
                <i style={customStyles.iconsBar} className="bi bi-plus"></i>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="cancelChangesBtn"
            style={{ marginRight: "10px" }}
            variant="outline-secondary"
            disabled={isSaving}
            onClick={() => {
              setShowModalProcessingPhotos(false);
              setShowList(true);
            }}
          >
            {t("global:buttons.cancel")}
          </Button>

          <Button
            id="confirmChangesBtn"
            variant="primary"
            disabled={!activeImport || isSaving}
            onClick={async () => {
              if (
                !imgRef.current ||
                !completedCrop?.width ||
                !completedCrop?.height
              )
                return;
              setIsSaving(true);
              const croppedBlob = await getCroppedImgWebP(
                imgRef.current,
                completedCrop
              );
              if (croppedBlob) {
                const croppedUrl = URL.createObjectURL(croppedBlob);
                setListImages((prev) =>
                  prev.map((img) =>
                    img.name === itemToEdit.name
                      ? { ...img, url: croppedUrl, blob: croppedBlob }
                      : img
                  )
                );
                setShowModalProcessingPhotos(false);
                setShowList(true);
              }
              setIsSaving(false);
            }}
          >
            {isSaving ? (
              <TextLoading
                text={t("global:buttons.importing")}
                variant="light"
              />
            ) : (
              t("global:buttons.save")
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/** Modal delete item*/}
      <Modal
        show={showDeleteModal}
        size="md"
        aria-labelledby="contained-modal-title-md"
      >
        <Modal.Header className="modal-header">
          <Modal.Title className="modal-title text-center">
            {t("student:ModalImportProfilePhotos.titleDeleteItem")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            maxHeight: height - 200 + "px",
            overflow: "auto",
          }}
        >
          <Container>
            <Row>
              <Col xs={2} sm={2} md={2} lg={2} className="ps-0">
                <div style={customStyles.imgContainer}>
                  <img
                    id="studentProfilePhotoToDelete"
                    src={itemToDelete.url}
                    alt={itemToDelete.name}
                    style={customStyles.img}
                  />
                </div>
              </Col>
              <Col xs={10} sm={10} md={10} lg={10}>
                <b>{itemToDelete.student.full_name}</b>
                <br />
                <b>
                  {itemToDelete.student.school_level}
                  {" - "}
                  {itemToDelete.student.grade_group &&
                  itemToDelete.student.grade_group !== "N/A"
                    ? itemToDelete.student.grade_group
                    : itemToDelete.student.program_name}
                </b>
                <br />
                <b>{t("student:ModalImportProfilePhotos.curp")}:</b>{" "}
                {itemToDelete.student.curp || "N/A"}{" "}
                <b>{t("student:ModalImportProfilePhotos.idNumber")}:</b>{" "}
                {itemToDelete.student.student_unique_id || "N/A"}
                <br />
                <p>{itemToDelete.name}</p>
              </Col>
            </Row>
          </Container>
          <br />
          <p>{t("student:ModalImportProfilePhotos.deleteMsgConfirm")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="cancelDeleteItemBtn"
            style={{ marginRight: "10px" }}
            variant="outline-secondary"
            disabled={isSaving}
            onClick={() => {
              setShowDeleteModal(false);
              setShowList(true);
            }}
          >
            {t("global:buttons.close")}
          </Button>
          <Button
            id="deleteItemBtn"
            variant="primary"
            disabled={!activeImport || isSaving}
            onClick={() => removeItemFromList(itemToDelete)}
          >
            {isSaving ? (
              <TextLoading
                text={t("global:buttons.deleting")}
                variant="light"
              />
            ) : (
              t("global:buttons.accept")
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/** Modal success import photos*/}
      <ModalSuccess
        showModalSuccess={showModalSuccess}
        title={t("student:ModalImportProfilePhotos.Processing")}
        message={t("student:ModalImportProfilePhotos.ProcessingMsg")}
        fnAcceptButton={() => {
          setShowModalSuccess(false);
          props.setShowModalProcessingPhotos(false);
        }}
        size="lg"
      />
    </>
  );
}
ModalProcessingProfilePhotos.propTypes = {
  showModalProcessingPhotos: PropTypes.bool,
  setShowModalProcessingPhotos: PropTypes.func,
  imageZipFile: PropTypes.array,
};
